module.exports = __webpack_public_path__ + "static/media/b9-泰安桥.80ad3cf4.png";